export function format(first?: string, middle?: string, last?: string): string {
  return (first || '') + (middle ? ` ${middle}` : '') + (last ? ` ${last}` : '');
}

export function urlToBreadcrumb(urlStr: string, divider: string = ">") {
	let breadcrumb = '';
	try {
		const url = new URL(urlStr);
		let segments =  url.pathname.split("/");
		segments = segments.filter((segment) =>  segment !== '' && !segment.includes("index"));
		segments.forEach((segment, i) => {
			const extensionIndex = segment.lastIndexOf(".");
			if (extensionIndex !== -1) {
				segment = segment.substring(0, extensionIndex);
			}
			breadcrumb += `<span>${segment}</span>${i < segments.length - 1 ? divider : ""}`;
		});
	} catch {
		console.error(`failed to convert URL '${urlStr}'`);
	}
	return breadcrumb;
}

export function getAuthorNamesArray(str):string[] {
	// Split the string by spaces
	const parts = str.split(' ');

	// Initialize an empty array to hold the names
	const names = [];

	// Initialize a temporary array to hold the current name parts
	let currentNameParts = [];

	// Iterate over the parts array
	for (let i = 0; i < parts.length; i++) {
		// Check if the current part is a number
		if (!isNaN(parts[i])) {
			// If we have collected name parts, join them and add to the names array
			if (currentNameParts.length > 0) {
				names.push(currentNameParts.join(' '));
				currentNameParts = [];
			}
			// Skip the current part (the number)
			continue;
		}

		// Add the current part to the current name parts
		currentNameParts.push(parts[i]);
	}

	// Add the last collected name parts to the names array
	if (currentNameParts.length > 0) {
		names.push(currentNameParts.join(' '));
	}

	return names;
}

export function wrapAuthorWithItemProp(str:string) {
	return str.split(',').map((author) => {
		return `<span itemprop="author" itemtype="http://schema.org/Person">${author}</span>`;
	}).join(', ');
}